/* eslint-disable parog-web/no-glint-expect-error-directive */
import { concat, get } from '@ember/helper';
import Component from '@glimmer/component';
import eq from 'ember-truth-helpers/helpers/eq';
import gt from 'ember-truth-helpers/helpers/gt';
import type JesHistoryTableColumnComponent from 'parog-web/components/jes-history-table/column';
import LinkToForc from 'parog-web/components/link-to-forc';
import type Patient from 'parog-web/models/patient';
import fuiDropdown from 'wise-fui-modules/modifiers/fui-dropdown';
import type JesHistoryTableComponent from '../jes-history-table';

interface Signature {
  Args: {
    patient: Patient;
    table: JesHistoryTableComponent;
  };
}

export default class JesHistoryTableAddButtonComponent extends Component<Signature> {
  get actionnableColumns(): JesHistoryTableColumnComponent[] {
    // If a column does not have a @feature and a @component provided then it is not counting as a possible action
    return this.args.table.columns.filter(column =>
      Boolean(column.fullComponentId)
    );
  }

  <template>
    {{#let 'ui primary mini right floated button' as |buttonClasses|}}
      {{#if (eq this.actionnableColumns.length 1)}}
        <LinkToForc
          {{! @glint-expect-error }}
          @feature={{get @table.columns '0.args.feature'}}
          {{! @glint-expect-error }}
          @component={{get @table.columns '0.args.component'}}
          @patient={{@table.patient}}
          class={{buttonClasses}}
          data-test-add-button
        >

          {{! @glint-expect-error }}
          {{yield}}
        </LinkToForc>
      {{else if (gt this.actionnableColumns.length 1)}}
        <button
          class={{concat buttonClasses ' floating dropdown'}}
          type='button'
          {{fuiDropdown}}
          data-test-add-button
        >
          <div class='text'>

            {{! @glint-expect-error }}
            {{yield}}
          </div>
          <i class='dropdown icon'></i>
          <div class='menu' {{@table.dropdownMenu.register}}>
            {{! content will be replaced by an in-element call }}
          </div>
        </button>
      {{/if}}
    {{/let}}
  </template>
}
